import { render, staticRenderFns } from "./AktivitaetenReiter.vue?vue&type=template&id=937e3f9e"
import script from "./AktivitaetenReiter.vue?vue&type=script&lang=js"
export * from "./AktivitaetenReiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports